"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var expression_eval_1 = require("expression-eval");
var utils_1 = require("./utils");
exports.evaluate = function (state, path, node) {
    var _a, _b;
    var _c = utils_1.getID(path), feature = _c[0], inputId = _c[1];
    var value = expression_eval_1.eval(node, state);
    return __assign({}, state, (_a = {}, _a[feature] = __assign({}, state[feature], (_b = {}, _b[inputId] = value, _b)), _a));
};
//# sourceMappingURL=evaluate.js.map